import { FC } from "react";
import { Alert, Box } from "@mui/material";

import { RiInformationLine } from "react-icons/ri";

import {
  Claim,
  FeeChange,
  ManualPaymentFields,
} from "../../../../../types/claims";
import StatusChip from "../../table-components/StatusChip";
import { describeManualPayment } from "./manualPayments";
import { EditErrorAlert, SummaryRow } from "./ClaimEditDialogParts";
import PaymentEffect from "./PaymentEffect";

interface RecordPaymentConfirmProps {
  claim: Claim;
  fields: ManualPaymentFields;
  document: File | null;
  /** The preview's FeeChange; null when it couldn't be computed. */
  fee: FeeChange | null;
  saveError?: string;
  /** Re-runs a failed preview. */
  onRetry?: () => void;
  isRetrying?: boolean;
}

/** The second step of RecordPaymentDialog: a summary before saving. */
const RecordPaymentConfirm: FC<RecordPaymentConfirmProps> = ({
  claim,
  fields,
  document,
  fee,
  saveError,
  onRetry,
  isRetrying,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
    <Alert
      severity="warning"
      icon={<RiInformationLine size={20} />}
      sx={{ maxWidth: "100%" }}
    >
      This can't be edited.
    </Alert>

    <Box>
      {describeManualPayment(fields).map((row) => (
        <SummaryRow key={row.label} label={row.label}>
          {row.label === "Outcome" ? (
            <StatusChip status={fields.outcome} fitContent />
          ) : (
            row.value
          )}
        </SummaryRow>
      ))}
      {document && (
        <SummaryRow label="Correspondence">{document.name}</SummaryRow>
      )}
    </Box>

    <PaymentEffect claim={claim} fee={fee} />

    {saveError && (
      <EditErrorAlert
        message={saveError}
        onRetry={onRetry}
        isRetrying={isRetrying}
      />
    )}
  </Box>
);

export default RecordPaymentConfirm;
